import { useStanQuery } from '@/queries';
import { QUERY_KEYS } from '@/lib';
import { fetchMyAffiliateLinks } from '@/lib/api/affiliate-links';
import { useAuthStore } from '@/stores';

export function useMyAffiliateLinks() {
    // Include token in query key to ensure fresh data per account, specific issue related to account switching
    const token = useAuthStore(state => state.token);

    return useStanQuery(
        {
            queryKey: [QUERY_KEYS.MY_AFFILIATE_LINKS, token],
            queryFn: ({ signal }) => fetchMyAffiliateLinks(signal),
            staleTime: 5 * 60 * 1000, // 5 minutes
            meta: {
                error: {
                    sentryMessage: '[AFFILIATE_LINKS] failed-to-fetch-my-affiliate-links',
                },
            },
        },
        true
    );
}
